<template>
    <div>
        <top-navbar></top-navbar>
<div>
  

<div class="mb-5 background_color">


  <h6    class="manage-boder pt-2 font1  decoration"> <router-link class="decoration" to="/"> Home </router-link> <span class="pfimg3 "><i class="fa fa-angle-right" aria-hidden="true"></i></span>Customer<span class="pfimg3 "><i class="fa fa-angle-right" aria-hidden="true"></i></span>Issue Tracking<span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" to="/issuetracking/index">Manage Issue</router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span>   View Issue Tracking  </h6>



  <div class="container-fluid background_color">
 
    <b-modal :id="infoModal7.id" 
     :header-bg-variant="headerBgVariant"
      :header-text-variant="headerTextVariant"
      size="lg" hide-footer
     bottom>

     <template  #modal-title>
     
     <h5 >Share by Email</h5>


   </template>
   <div class="row mb-1">
    <div class=" col-md-6">
      <input placeholder="To"  v-model="mailshair.toemail" class="form-control input5 input6 bdr-rad font-size_def" >

      
      </div>
    
   </div>
   <div class="row mb-1">
    <div class=" col-md-6">
      <input placeholder="Subject"  v-model="mailshair.subject" class="form-control input5 input6 bdr-rad font-size_def" >

      
      </div>
    
   </div>
   <div class="row mb-1">
    <div class=" col-md-12">
      <textarea placeholder="Body"  v-model="mailshair.body" class="form-control font-size_def" rows="14"></textarea>

      
      </div>
    
   </div>

   <div style="border-bottom: 0px; padding-top: 0px;" class="navbar">
    
    <div class="d-flex  ">
     
    </div>
    <div class="d-flex  ">
      <button  type="submit" @click="mailSend(infoModal7.content)"  style="background-color: #2642a7;color: white;" class="btn btn-sm btn mb-1 font-size_def bdr-rad bdr-rad"  > Send</button>
    </div>
    </div>

   
  
  </b-modal>


<div class="card mt-1">
<div class="card-body">


    <table style="font-size: small; " class="table table-hover  table-sm table-borderless table-responsive  ">
       
          <tbody>

            <tr>
              <td class="width-custom2"><b>ID </b></td>
             <td>{{ issue.id}}</td>
             <td style="text-align: right;width: 280px;">  
              <button v-show="![49, 51].includes(issue.status)" type="button" @click="shairEmail(issue.id)" class="btn btn-sm btn-outline-primary bdr-rad mt-1">Share by Email </button></td> 
            </tr>

            <tr>
              <td class="width-custom2"><b>Ticket Number </b></td>
              <td >{{issue.issue_no}}</td> 
              <td></td>
            </tr>
            <tr>
              <td><b>Citizen Name</b></td>
              <td>{{ issue.first_name}} {{issue.surname  }}</td> 
              <td></td>
            </tr>
            <tr>
              <td><b>Main Category</b></td>
              <td>{{issue.relatedToMaincategory.category_name }}</td> 
              <td></td>
            </tr>
           
            <tr>
              <td><b>Sub Category</b></td>
              <td>{{issue.relatedToSubcategory.category_name }}</td> 
              <td></td>
            </tr>
            
          
            <tr>
              <td><b>Citizen Mobile </b></td>
              <td>{{issue.mobile }}</td> 
              <td></td>
            </tr>
            <tr>
              <td><b>Description </b></td>
             <td>{{issue.description }}</td>
             <td></td> 
            </tr>
            <tr>
              <td><b>Citizen Email </b></td>
              <td>{{issue.email }}    <button type="button"  @click="shairEmail(issue.id)"  class="btn btn-sm btn-outline-primary bdr-rad ms-3">Email Citizen</button></td> 
             <td></td> 
            </tr>
           
            <tr>
              <td><b>Feedback type</b></td>
              <td>{{issue.feedback }}</td> 
              <td></td>
            </tr>
            <tr>
              <td><b>Address</b></td>
              <td> {{issue.address }}</td> 
              <td></td>
            </tr>
            <tr>
              <td><b>Lat,Long</b></td>
              <td>{{issue.latitude }} , {{ issue.longitude }}</td> 
              <td></td>
            </tr>
            <tr>
              <td><b>Description  </b></td>
              <td>{{issue.description }}</td> 
              <td></td>
            </tr>

            <tr v-if="uploadedFile1">
  <td><b> Image 1</b></td>
  <td>
    <a style="cursor:pointer"  @click="imageLoad1(uploadedFile1)" >
      <img :src="uploadedFile1" alt="Uploaded Image 1" style="max-width: 100px;" />
    </a>
  </td> 
  <td></td> 
</tr>

<tr v-if="uploadedFile2">
  <td><b>Image 2</b></td>
  <td>
    <a style="cursor:pointer"  @click="imageLoad2(uploadedFile2)" >
      <img :src="uploadedFile2" alt="Uploaded Image 2" style="max-width: 100px;" />
    </a>
  </td> 
  <td></td> 
</tr>

<tr v-if="uploadedFile3">
  <td><b> Image 3</b></td>
  <td>
    <a style="cursor:pointer"  @click="imageLoad3(uploadedFile3)" >
      <img :src="uploadedFile3" alt="Uploaded Image 3" style="max-width: 100px;" />
    </a>
  </td> 
  <td></td> 
</tr>

<tr>
              <td><b>{{language[22]['Status']}} </b></td>
             <td v-show="this.lan=='English'">{{issue.relatedToStatus.status }}</td> 
             <td v-show="this.lan=='Swedish'">{{issue.relatedToStatus.swedish_status }}</td> 
             <td></td> 
            </tr>
            <tr>
              <td><b>Created Date</b></td>
             <td>{{ formatDate(issue.created_date) }}</td> 
             <td></td> 
            </tr>
         
           
             
          </tbody>


        </table>


      </div>
    </div>


    <div class="card custom_bdr_rds shadow p-2">
                        <div class="card-body custom_bdr_rds">
                            <h6 class="purchitem mb-2"><b>{{language[33]['Allocated Contractor']}} </b></h6>

                        <div class="table-responsive">
                      
                        <table style="font-size: small; " class="table table-hover table-sm table-borderless ">
                            <thead class="background_color2" >
                              <tr class="custom-label2">
                              <th>#</th>
                              <th>{{language[32]['Sub Ticket Number']}} </th>
                              <th>{{language[34]['Name']}} </th>
                              <th>{{language[75]['Mobile']}} </th>
                              <th>{{language[76]['Email']}} </th>
                              <th>{{language[22]['Status']}} </th>
                              <th>{{language[77]['Action']}} </th>
                            
                              </tr>
                            </thead>
                            <tbody>
                              <tr  v-for="(contractor, index) in contractors" :key="contractor.id">
                              <td>{{index+1}}</td>
                              <td>{{contractor.sub_issue_no}}</td>
                              <td>{{contractor.name}}</td>
                              <td>{{contractor.mobile}}</td>
                              <td>{{contractor.email}}</td>
                              <td>
                              
                              
                              <div style="background-color: #ee68f9;text-align: center;border-radius: 12px;padding: 4px;" v-show="contractor.statusvalue==42" >{{ contractor.status }} </div>
                              <div  v-show="contractor.statusvalue==49" style="background-color: green;text-align: center;border-radius: 12px;padding: 4px;">{{ contractor.status }}
                                 </div>
                            
                              <div  v-show="contractor.statusvalue==50" style="background-color: #e8f916 ;text-align: center;border-radius: 12px;padding: 4px;">{{ contractor.status }}
                                 </div>
                             
                      <div class="active-status" v-show="contractor.statusvalue==1" >{{ contractor.status}} </div>
                      <div class="open-status" v-show="contractor.statusvalue==20" >{{ contractor.status }} </div>
                      <div class="close-status" v-show="contractor.statusvalue==21" >{{ contractor.status }} </div>
                      <div class="reopen-status" v-show="contractor.statusvalue==51" >{{ contractor.status }} </div>
                      <div class="inprogress-status" v-show="contractor.statusvalue==25" >{{ contractor.status }} </div>

                              </td>
                             
                              <td> <button  @click="jobView(contractor.alocate_id)"  class="btn btn-outline-primary btn-sm bdr-rad font-size_def">  {{language[28]['View']}} </button></td>
                            
                              </tr>
                            </tbody>

                          </table>
    
                        </div>

                      </div>
                    </div>



                     <div class="card custom_bdr_rds shadow p-2">
                        <div class="card-body custom_bdr_rds"> 
                            <h6 class="purchitem mb-2"><b>{{language[132]['Case Notes']}}</b></h6>

                        <div class="table-responsive">
                      
                        <table style="font-size: small; " class="table table-hover table-sm table-borderless ">
                            <thead class="background_color2" >
                              <tr class="custom-label2">
                              <th>#</th>
                              <th>{{language[39]['Comment']}} </th>
                              <th>{{language[23]['Created Date']}} </th>
                              <th>{{language[40]['Action By']}} </th>
                              <th>{{language[41]['Created By']}} </th>
                              <th>{{language[42]['Created Type']}} </th>
                              <th>{{language[133]['Attach file']}} </th>
                           
                            
                              </tr>
                            </thead>
                            <tbody> 
                              <tr v-if="issue.description">
                                <td>1</td>
                                <td>{{ issue.description }}</td>
                                <td>{{ formatDate(issue.created_date) }}</td>
                                <td></td>
                                <td>{{ issue.first_name}} {{issue.surname  }}</td>
                                <td>{{language[73]['Citizen']}} </td>
                                <td></td>
                              </tr>
                              <tr  v-for="(crmnote, index) in crmnotes" :key="crmnote.id">
                              <td  v-if="issue.description">{{index+2}}</td>
                              <td  v-if="!issue.description">{{index+1}}</td>
                              <td>{{crmnote.comment}}</td>
                              <td>{{crmnote.created_date}}</td>
                              <td>{{crmnote.actionby}}</td>
                              <td>{{crmnote.created_by}}</td>
                              <td>{{crmnote.type1}}</td>
                              <td><a href="">   <img class="ms-4"   src="../../../public/img/word.png" width="30px" >  </a></td>
                            
                            
                              </tr>
                            </tbody>

                          </table>
    
                        </div>


                        <br>

       
             

                <div class="row">
                  <div class="col-md-3">
                    <div class="form-group ">
                            <label class="custom-label">{{language[39]['Comment']}}  </label>
                            <textarea rows="3" v-model="crm.comments"  class="form-control font-size_def" ></textarea>
                    </div>
                  </div>
             
                  <div class="col-md-3">
                    <div class="form-group ">
                            <label class="custom-label" >{{language[23]['Created Date']}} </label>
                            <input v-model="crm.followup_date" type="date"   class="form-control font-size_def" >
                    </div>
                  </div>
                  <div class="col-md-3">
                    <div class="form-group ">
                            <label class="custom-label">{{language[40]['Action By']}} </label>
                            <v-select class="font-size_def" label="name" :options="alo_contractors" v-model="crm.actionby" ></v-select>
                           
                           
                    </div>
                  </div>


                </div>
           
           <div style="border-bottom: 0px; padding-top: 0px;" class="navbar">

           <div class="d-flex  ">
           
           </div>
           <div class="d-flex  ">
               <button @click="crmCreate()"  class="mr-1 btn btn-outline-primary btn-sm  mb-0 mt-0 font-size_def bdr-rad">{{language[118]['Add Note']}} </button>
           </div>
           </div>





                   </div>
               </div>




   
    

    






<br><br><br>
</div>
</div>









</div>






        
        <content-footer></content-footer>
    </div>
</template>
<script>
 import axios from 'axios';
 import authService from '@/auth.service';
  import TopNavbar from './../../layout/TopNavbar.vue'
  import ContentFooter from './../../layout/ContentFooter.vue'
  import vSelect from 'vue-select';

  export default {
    data() {
      return {
        access_token:authService.isLoggedIn(),
        userid:authService.isUserid(),
        language:JSON.parse(authService.isLanguage()),
        'idIssue':this.$route.query.id,
        uploadedFile1: '',  
        uploadedFile2: '',  
        uploadedFile3: '',  
        issue:{},
        lan:{},
      
        infoModal7: {
          id: 'info-modal7',
          title: '',
          content: [],
        },
        mailshair:{
          'body':'',
        },
        crmnotes:[],
        crm:{
           followup_date: '',
        },
      


        
      }

    },
    mounted(){
 
  this.loadCrm();
    },

    computed: {
    roundToTwoDecimal() {
      return detail => parseFloat(detail).toFixed(2);
    }
  },
methods : {

  formatDate(dateString) {
    const date = new Date(dateString); // Create a new Date object from the string

    // Manually format the date as DD-MM-YYYY with dashes
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const year = date.getFullYear();

    const formattedDate = `${day}-${month}-${year}`; // Combine date as DD-MM-YYYY
    
    // Format the time as HH:MM in 24-hour format
    const formattedTime = date.toLocaleTimeString('en-GB', {  
      hour: '2-digit', minute: '2-digit'
    });

    return `${formattedDate} ${formattedTime}`;  // Combine date and time
  },

  async mailSend(id){

this.$root.$emit('bv::hide::modal', this.infoModal7.id);
try {
  const { data} = await  axios.post('/issuetracking/issuemailsend?id='+id,{userid:this.userid,mailshair:this.mailshair},{
    headers:{
      'Authorization':'Bearer '+this.access_token,
      'Content-type': 'application/json',
     
    }
   });
   console.log(data);
   if(data.status==200){
   window.location.reload();
  
    
   
   }
  
} catch (error) {
  console.log(error.response);
  
}

},

      
  async shairEmail(id){

try {
const { data} = await  axios.get('/issuetracking/loademaildata?id='+id,{
  headers:{
    'Authorization':'Bearer '+this.access_token,
    'Content-type': 'application/json',
   
  }
 });
 console.log(data);
 if(data.status==200){
 this.mailshair.body = data.body;
this.infoModal7.content = id;
this.$root.$emit('bv::show::modal', this.infoModal7.id);
 }

} catch (error) {
console.log(error.response);
}


},

  
  
  async loadCrm() {
   
    try {
      const { data} = await  axios.get('/issuetracking/view?id='+this.idIssue,{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       this.issue = data.issues;
       this.uploadedFile1 = data.uploadedFile1;
       this.uploadedFile2 = data.uploadedFile2;
       this.uploadedFile3 = data.uploadedFile3;
       this.lan = data.lan;
      
    } catch (error) {
      console.log(error.response);
    }
  },




},

    components :{
        ContentFooter,
        TopNavbar,
        'v-select': vSelect,
    },
  }

</script>
<style >

</style>